import {ezGlobals} from 'ez_globals';

const {ezcaterUrl} = ezGlobals;
const origin = window.location.origin || `${window.location.protocol}//${window.location.host}`;
const baseInternalApiUrl = `${origin}/landings_api`;

export const POST_REFER_A_FRIEND = `${ezcaterUrl}/api/consumer/v1/refer_a_friend_attribution`;

export const BRAND_MULTIPLE_ADDRESSES = `${baseInternalApiUrl}/brand_multiple_addresses`;

export const BRAND_REVIEWS = `${baseInternalApiUrl}/brands/${ezGlobals.urlId}/reviews`;

export const CATERER_REVIEWS = `${baseInternalApiUrl}/caterers/${ezGlobals.urlId}/reviews`;

export const CALENDAR_EVENTS = `${baseInternalApiUrl}/calendar_events`;
